<template>
  <Cmodal
    v-model="model"
    cancel-label="Never mind"
    centered
    size="md"
    title="Permission Approval"
    :tag="false"
    label=""
    confirm-label="Submit PIN"
    :progressing="progressing"
    @submit="verifyPin"
  >
    <template>
      <div class="mb-3">
        An Approval PIN for this permission request was sent to {{ user.FirstName + ' ' + user.LastName }} user as approver.The
        PIN expires in 15 minutes.
      </div>
      <div>
        Please ask approver to enter PIN below and submit to proceed.
      </div>
      <div class="text-center mb-3">
        Action to permit : {{ actionType }}
        <span class="font-weight-bold">Tab {{ tabNo }}</span>
      </div>

      <div class="text-center">
        <PincodeInput v-model="pin" length="6" />
      </div>
    </template>
  </Cmodal>
</template>

<script>
import Cmodal from './Cmodal'
import PincodeInput from 'vue-pincode-input'
export default {
  name: 'PinVerification',
  components: {
    Cmodal,
    PincodeInput
  },
  props: {
    value: {required: true, type: Boolean, default: false},
    actionType: {required: true, type: String},
    user: {required: true},
    ApprovalIkey: {required: true},
    tabNo: {
      type: [Number, String],
      default: ''
    },
    orderId: {
      required: true
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      pin: '',
      progressing: false
    }
  },
  methods: {
    verifyPin() {
      if (this.pin && this.pin.length === 6) {
        const data = {
          // UserID: localStorage.getItem('userID'),
          RestaurantID: this.$store.state.selectedRestaurantId,
          ApprovalUserID: this.user.ClientID,
          VerificationCode: this.pin,
          IKey: this.ApprovalIkey
        }
        return this.$api.getRestaurant.ProceedVerificationApprovalCode(data).then(res => {
          if (res.success && res.IsValidate) {
            this.model = false
            this.$emit('successPin')
          } else {
            this.$showError('pin is not valid')
          }
        })
      }
    }
  }
}
</script>

<style></style>
